export default __webpack_public_path__ + "ebcb07bb352b6588bb2d5db1727c22cd.svg";